(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["omnikeys-marquee-brands"] && !Shopify.designMode) return;
  try {
    
/**
 * OmniKeys Brand Marquee — Infinite scroll via DOM clone
 * Duplica el .ok-bm-belt para que la animación CSS sea verdaderamente continua.
 */
(function () {
  'use strict';

  function initMarquee(trackEl) {
    var belt = trackEl.querySelector('.ok-bm-belt');
    if (!belt) return;

    // Clonar el belt para bucle infinito
    var clone = belt.cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    trackEl.appendChild(clone);
  }

  document.querySelectorAll('.ok-bm-track').forEach(initMarquee);
})();

  } catch(e) { console.error(e); }
})();
})();
